import script from "./TopScoringListSelectionView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopScoringListSelectionView.vue?vue&type=script&lang=ts&setup=true"

import "./TopScoringListSelectionView.vue?vue&type=style&index=0&id=1f89bd2c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f89bd2c"]])

export default __exports__